import React from 'react';
import PropTypes from 'prop-types';
import { Box, Paper } from '@mui/material';
import AssignTags from '../advertisers/assign-tags.component';

const AppMonetizationType = ({ channelDetail }) => (
  <Box component={Paper} p={2} width="100%">
    <AssignTags channelId={channelDetail.id} fromChannel />
  </Box>
);

AppMonetizationType.propTypes = {
  channelDetail: PropTypes.object.isRequired,
};

export default AppMonetizationType;
